import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Bullet-List--Streamline-Flex"
    >
        <desc>{'Bullet List Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="bullet-list--points-bullet-unordered-list-lists-bullets">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.00195 1.5h9.49785"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 1.5h0.339341"
                strokeWidth={1}
            />
            <path
                id="Vector_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.00195 7h9.49785"
                strokeWidth={1}
            />
            <path
                id="Vector_4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 7h0.339341"
                strokeWidth={1}
            />
            <path
                id="Vector_5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.00195 12.5h9.49785"
                strokeWidth={1}
            />
            <path
                id="Vector_6"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 12.5h0.339341"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
